export default __webpack_public_path__ + "static/media/WonderBlockly.f83cf9a8.png";